import { useState } from "react";
import { IGTableProps, SORT_COL, TSort } from "./GTableConsts";
import { TableCell, TableCellProps, TableHead, TableRow } from "@mui/material";
import { addClass } from "../GWidget";
import UserStorage from "../cache/UserStorage";

export function deserializeSort(col:TSort|string|undefined, defaultCol:string) : TSort {
    if (!col) return [defaultCol,1]
    else if (col instanceof Array) return col
    else if (col[0]=="-") return [col.substring(1),-1]
    else return [col, 1]
}
export function serializeSort(sort:TSort) : string {
    return sort[1]==-1 ? "-" + sort[0] : sort[0]
}

export function restoreSort(userPref:UserStorage<any>, tableName:string, defaultCol:string) : TSort {
    const sorts = userPref.get(SORT_COL, {})
    return  deserializeSort(sorts[tableName], defaultCol)
}

export function saveSort(userPref:UserStorage<any>|undefined, tableName:string, sort:TSort) {
    userPref?.addHash(SORT_COL, {[tableName] : serializeSort(sort)}).save()
}

export default function useGTableHeader<T>(props:IGTableProps<T>){
    const saved:TSort = props.userPref ? 
        restoreSort(props.userPref, props.tableName, props.cols[0]) : 
        deserializeSort(props.sort, props.cols[0])

    const [sort,setSort] = useState<TSort>(saved)

    const onSort = (col:string) => {
        return () => {
            let newSort : TSort = [col, sort[0]==col ? -sort[1] : 1]
            props.onSort?.(col, newSort[1])
            saveSort(props.userPref, props.tableName, newSort)
            setSort(newSort)
        }
    }

    const renderer = props.headerCell 
        ? props.headerCell 
        : (col:string) => <div>{props.label ? props.label(col) : col}</div>

    const hd = props.cols.map(col => {
        const cellProps : TableCellProps = props.disableSort ? {} : {onClick:onSort(col)}
        const className = col==sort[0] ? "sort " + (sort[1]>0 ? "asc" : "dsc") : ""
        const customProps = props.headerCellProps ? props.headerCellProps(col, sort[0], sort[1], props.data) : {}
        customProps.className = addClass(className, customProps)
        return <TableCell key={col} {...cellProps} {...customProps}>{renderer(col, sort[0], sort[1], props.data)}</TableCell>
    })
    return {header:<TableHead><TableRow>{hd}</TableRow></TableHead>,sort}
}
